<template>
  <Signin />
</template>

<script>
import Signin from '../components/Signin.vue'
export default {
  name: 'Signin-page',
  components: {
    Signin
  }
}
</script>
